import { css } from 'styled-components';
import { map } from '../../breakpoint';
export const overflow = ()=>css`
  ${({ overflow })=>map(overflow, (val)=>val !== undefined && css`
          overflow: ${val};
        `)};
`;

//# sourceMappingURL=overflow.js.map